// eslint-disable-next-line
import util from 'util';
import * as PortalApi from './PortalApi';

/*
 * Portal API calls
 */


/*
 * Query the current users
 */
export function queryWebUser(complete) {
  PortalApi.get('/api/me', undefined, (status, content) => complete(content));
}


/*
 * Create a new session
 */
export function createSession(identityKey, complete) {
  PortalApi.post('/api/auth/' + identityKey, undefined,
                 (status, content) => complete(content));
}

/*
 * End the current session
 */
export function endSession(complete) {
  PortalApi.post('/api/me/endSession', undefined,
                 (status, content) => complete(status));
}

/*
 * Get the Stripe public key, pass in either STRIPE_US, or STRIPE_CA to get the necessary key.
 */
export function queryStripePublicKey(complete, paymentProcessorSpecific) {
  PortalApi.get('/api/paymentProcessor/publicKey', {'paymentProcessor': paymentProcessorSpecific},
                 (status, content) => complete(content));
}

/*
 * Get the Stripe ProcessorId for this specific host. This should not accept any input from the client.
 */
export function queryStripeProcessorId(complete) {
  PortalApi.get('/api/paymentProcessor/paymentProcessorId', undefined,
      (status, content) => complete(content));
}

/*
 * Get the Stripe ProcessorId for this specific host. This should not accept any input from the client.
 */
export function queryPortalCDNScripts(complete) {
  PortalApi.get('/api/paymentProcessor/scripts/zoho', undefined,
      (status, content) => complete(content));
}

/*
 * Get the referral URL for the specified payment processor id.
 */
export function queryPaymentProcessorReferralUrl(complete, fail, paymentProcessorSpecific) {
  PortalApi.get('/api/paymentProcessor/' + paymentProcessorSpecific + '/referralUrl', undefined,
      (status, content) => complete(content), fail);
}


/*
 * Get the payment accounts list
 */
export function queryPaymentAccounts(complete, fail) {
  PortalApi.get('/api/me/paymentAccounts', undefined,
                complete, fail);
}

/*
 * Get the payment surcharge prompt
 */
export function queryPaymentSurcharge(complete, fail, accountId, amount, methodType, funding) {
  PortalApi.post('/api/payments/surcharge', {accountId, amount, methodType, funding},
      (status, content) => complete(content), fail);
}

/*
 * Submit a token payment.  Note that amount is in pennies and not dollars
 */
export function submitTokenPayment(complete, fail, accountId, token, amount,
                                   save, receiptEmail, metadata, enableAutoPayFl, autoPayEmailAddress) {
  let autoPayStatus = enableAutoPayFl ? 'Y' : 'N';

  if (metadata) {
    metadata = JSON.stringify(metadata);
  }
  PortalApi.post('/api/payments', { accountId, token, amount, save, receiptEmail, metadata, autoPayStatus, autoPayEmailAddress},
                 complete, fail);
}

/*
 * Submit a stored payment method payment.  Note that amount is in pennies and not dollars
 */
export function submitMethodPayment(complete, fail, paymethodId, amount, receiptEmail, metadata) {
  let str_metadata ="";
  if (metadata) {
    metadata = JSON.stringify(metadata);
  }
  PortalApi.post('/api/payments', { paymethodId, amount, receiptEmail, metadata },
                 complete, fail);
}

/*
 * Add a new credit card - the card will be returned from Stripe as a token, which is all we have.
 */
export function addCard(complete, fail, accountId, token, enableAutoPayFl, autoPayEmailAddress) {
  let autoPayStatus = enableAutoPayFl ? 'Y' : 'N';
  PortalApi.post('/api/paymentMethods/card', { accountId, token, autoPayStatus, autoPayEmailAddress}, complete, fail);
}

/*
 * Add a new credit card - the card will be returned from Stripe as a token, which is all we have.
 */
export function updateCardAutoPayFl(complete, fail, paymethodId, autoPayFl, autoPayEmailAddress) {
  PortalApi.put('/api/paymentMethods/' + paymethodId + '/update', {autoPayFl, autoPayEmailAddress}, complete, fail);
}

/*
 * Request ACH crebit instructions
 */
export function addAchCreditInstructions(complete, fail, accountId) {
  PortalApi.post('/api/paymentMethods/achc',
                 { accountId },
                 complete, fail);
}

/*
 * Add an ACH debit account
 */
export function addAchDebit(complete, fail, accountId, accountHolderName, accountType, routingNumber, accountNumber, transitNumber, padSingleUse, email) {
  PortalApi.post('/api/paymentMethods/ach',
                 { accountId, accountHolderName, accountType, routingNumber, accountNumber, transitNumber, padSingleUse, email },
                 complete, fail);
}

/*
 * Verify an ACH debit account
 */
export function verifyAchDebit(complete, fail, paymethodId, firstDeposit, secondDeposit, descriptorCode, enableAutoPayFl, autoPayEmailAddress) {
  let autoPayStatus = enableAutoPayFl ? 'Y' : 'N';
  PortalApi.post('/api/paymentMethods/' + encodeURIComponent(paymethodId) + '/verify',
                 { firstDeposit, secondDeposit, descriptorCode, autoPayStatus, autoPayEmailAddress },
                 complete, fail);
}
